import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { sendPageview } from "@/utils/firstPartyAnalytics";

/**
 * Skickar en anonym förstaparts-sidvisning vid varje verklig navigation
 * (inkl. första laddningen). Renderar inget. Ingen identifiering/PII.
 */
export default function PageviewTracker() {
  const location = useLocation();
  useEffect(() => {
    sendPageview(location.pathname);
  }, [location.pathname]);
  return null;
}
